import Decimal from 'decimal.js';
import useAppConfigStore from '../store/useAppConfigStore';

// export const safeRound = (value, customDecimals) => {
//     if (typeof value !== 'number' && typeof value !== 'string') return value;
    
//     // Get config from store
//     const { currencyFormat, decimalPlaces } = useAppConfigStore.getState();
    
//     // Use custom decimals if provided, otherwise use store value
//     const decimals = customDecimals ?? decimalPlaces;
    
//     // Round the value
//     const rounded = new Decimal(value).toDecimalPlaces(decimals).toNumber();
    
//     // Determine separators based on currency format
//     let thousandSeparator = ',';
//     let decimalSeparator = '.';
    
//     switch (currencyFormat) {
//         case '1,234,567.89':
//             thousandSeparator = ',';
//             decimalSeparator = '.';
//             break;
//         case '1.234.567,89':
//             thousandSeparator = '.';
//             decimalSeparator = ',';
//             break;
//         case '1 234 567,89':
//             thousandSeparator = ' ';
//             decimalSeparator = ',';
//             break;
//         case "1'234'567.89":
//             thousandSeparator = "'";
//             decimalSeparator = '.';
//             break;
//         case '1234567':
//             thousandSeparator = '';
//             decimalSeparator = '.';
//             break;
//         default:
//             thousandSeparator = ',';
//             decimalSeparator = '.';
//     }
    
//     // Convert to fixed decimal places
//     const fixedValue = rounded.toFixed(decimals);
//     const parts = fixedValue.split('.');
//     let integerPart = parts[0];
//     const decimalPart = parts[1];
    
//     // Handle negative numbers
//     const isNegative = integerPart.startsWith('-');
//     if (isNegative) {
//         integerPart = integerPart.substring(1);
//     }
    
//     // Add thousand separators
//     let formattedInteger = integerPart;
//     if (thousandSeparator) {
//         formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
//     }
    
//     // Add back negative sign if needed
//     if (isNegative) {
//         formattedInteger = '-' + formattedInteger;
//     }
    
//     // Combine integer and decimal parts
//     if (decimals > 0 && decimalPart) {
//         return `${formattedInteger}${decimalSeparator}${decimalPart}`;
//     }
    
//     return formattedInteger;
// };

export const safeRound = (value, customDecimals) => {
  if (value === '' || value === null || value === undefined) return value;

  // ✅ Allow partial numeric input
  if (
    typeof value === 'string' &&
    /^-?\d*\.?$/.test(value)
  ) {
    return value;
  }

  if (typeof value !== 'number' && typeof value !== 'string') return value;

  const { currencyFormat, decimalPlaces } =
    useAppConfigStore.getState();

  const decimals = customDecimals ?? decimalPlaces;

  let rounded;
  try {
    rounded = new Decimal(value)
      .toDecimalPlaces(decimals)
      .toNumber();
  } catch {
    return value; // fallback safety
  }

  let thousandSeparator = ',';
  let decimalSeparator = '.';

  switch (currencyFormat) {
    case '1.234.567,89':
      thousandSeparator = '.';
      decimalSeparator = ',';
      break;
    case '1 234 567,89':
      thousandSeparator = ' ';
      decimalSeparator = ',';
      break;
    case "1'234'567.89":
      thousandSeparator = "'";
      decimalSeparator = '.';
      break;
    case '1234567':
      thousandSeparator = '';
      decimalSeparator = '.';
      break;
  }

  const fixedValue = rounded.toFixed(decimals);
  const [intPart, decPart] = fixedValue.split('.');

  const isNegative = intPart.startsWith('-');
  const cleanInt = isNegative ? intPart.slice(1) : intPart;

  const formattedInt = thousandSeparator
    ? cleanInt.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator)
    : cleanInt;

  const finalInt = isNegative ? `-${formattedInt}` : formattedInt;

  return decimals > 0 && decPart
    ? `${finalInt}${decimalSeparator}${decPart}`
    : finalInt;
};
